import { prefix } from '@goldwasserexchange/react-topmodel';
export var listPrefixer = prefix('List');
